import React, { useEffect, useRef, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { useLocation, useParams } from "react-router-dom";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { API_HOST } from "../../Constants";
import { connectRealtimeBoundaryAreaWebSocket } from "../../websock/realtimeBoundaryAreaManager";
import PageHeader from "../PageHeader";

export default function BoundaryMapComponent() {
  const { id } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [floors, setFloors] = useState([]);
  const [boundaryPreviewImage, setBoundaryPreviewImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ledStatus, setLedStatus] = useState(null);
  const [equipments, setEquipments] = useState([]);
  const iconImages = useRef({}); // 아이콘 이미지들을 별도의 ref에 저장

  // 회로 배열 초기화
  const boundaries = [...Array(20)].map((_, index) => ({
    name: `회로 ${index + 1}`,
    shapeType: "rectangle",
    backgroundColor: null,
  }));

  useEffect(() => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getBuildingDetail(id);
      if (status === true) {
        if (data.floors.length > 0) {
          //첫번째 층으로 설정
          const firstFloor = data.floors[0];
          if (firstFloor.boundaryPreviewImage) {
            setBoundaryPreviewImage(API_HOST + firstFloor.boundaryPreviewImage);
          } else {
            setBoundaryPreviewImage(null);
          }
        }
        setFloors(data.floors.map(item => {
          return {
            floorLevel: item.floorLevel,
            floor: item.floor,
            boundaryPreviewImage: item.boundaryPreviewImage,
          }
        }));
      } else {
        alert(`${data}`);
      }
    });

    //회로 상태 실시간 확인 소켓 연결
    connectRealtimeBoundaryAreaWebSocket(id, (data) => {
      setLedStatus(data.ledStatus);
      updateBoundariesStatus(data.ledStatus);
    });

    // 아이콘 배열 초기화
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getBoundaryZoneMdbList();
      if (status === true) {
        const equipments = data.map(item => {
          return {
            src: API_HOST + item.iconImage,
            name: item.name,
            shapeType: "icon",
          }
        });
        setEquipments(equipments);

        // 이미지 로드 후 iconImages에 저장
        equipments.forEach((item) => {
          const image = new window.Image();
          image.src = item.src;
          image.crossOrigin = 'anonymous';
          image.onload = () => {
            iconImages.current[item.name] = image; // 아이콘 이름을 키로 사용해 이미지 저장
          };
          image.onerror = () => {
            console.error(`Failed to load image: ${item.src}`);
          };
        });
      } else {
        alert(`${data}`);
      }
    })

    const handleResizePreviewImage = () => {
      const wrap = document.querySelector(".map-img-wrap");
      const img = document.getElementById("map-img");

      img.style.width = `${wrap.clientHeight}px`;
      img.style.height = `${wrap.clientWidth}px`;
    }

    window.addEventListener("load", handleResizePreviewImage);

    const observer = new MutationObserver(handleResizePreviewImage);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("load", handleResizePreviewImage);
      observer.disconnect();
    }
  }, []);

  useEffect(() => {
    updateBoundariesStatus(ledStatus);
  }, [ledStatus]);

  const updateBoundariesStatus = (ledStatus) => {
    if (ledStatus !== null) {
      boundaries.map((item, index) => {
        //회로1~20 중 회로1~5까지만 존재함
        if (index < 5) {
          //data[3]~[7]이 회로1~5이므로 index + 3
          item.backgroundColor = ledStatus[index + 3] === 1 ? "red" : null;
        }
      });
    }
  }

  const handleItemClick = (e) => {
    const floorLevel = e.target.value;
    const target = floors.find((item) => item.floorLevel === parseInt(floorLevel));

    if (target.boundaryPreviewImage) {
      setBoundaryPreviewImage(API_HOST + target.boundaryPreviewImage);
    } else {
      setBoundaryPreviewImage(null);
    }
  }

  const openModal = () => {
    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  return (
    <>
      <section id="darkMode" class="mbSection darkMode pb-per">
        <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
        <div class="container pb-40 bt-w">
          <div class="btn-legend-wrap">
            <div class="input-wrap" style={{ width: 'fit-content' }}>
              <div class="input-item">
                <div class="select-wrap">
                  <select onChange={handleItemClick}>
                    {floors.length > 0 &&
                      floors.map((item, index) => (
                        <option value={item.floorLevel}>{item.floor}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <button class="btn-legend btn-open" onClick={openModal}>
              <i class="x-icon"></i>
              <p class="btn-title">범례</p>
            </button>
          </div>
          <div class="map-img-wrap">
            {boundaryPreviewImage === null ? (
              <p style={{ position: 'absolute', display: 'flex', justifyContent: 'center', top: '50%' }}>
                작성된 경계구역일람도가 존재하지 않습니다.
              </p>
            ) : (
              <img id="map-img" src={boundaryPreviewImage} alt="" />
            )}
          </div>
        </div>

        <div id="dashboardMenu" class="active_02">
          <DashboardMenu buildingName={buildingName} />
        </div>
        <FireOnMenu />
      </section>

      {isModalOpen && (
        <div id="modal" class="modal rightModal open"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeModal();
            }
          }}>
          <div class="modal_content">
            <button class="btn-legend btn-close" onClick={closeModal}>
              <p class="btn-title">범례</p>
              <i class="x-icon"></i>
            </button>

            <div class="wrap_legend">
              <div class="box_boundaryLegend">
                <p class="title_legend">경계구역 범례</p>
                <div class="wrap_blBtn">
                  {boundaries.length > 0 &&
                    boundaries.map((item, index) => (
                      <button key={index} class="item_blBtn" style={{ backgroundColor: item.backgroundColor }}>회로 {index + 1}</button>
                    ))}
                </div>
              </div>
              <div class="box_fireEquipmentLegend">
                <p class="title_legend">소방설비 범례</p>
                <div class="wrap_felBtn">
                  {equipments.length > 0 &&
                    equipments.map((item, index) => (
                      <div key={index} class="item_felBtn">
                        <div class="img_felBtn">
                          {item.src && <img src={item.src} alt={item.name} />}
                        </div>
                        <p class="title_felBtn">{item.name}</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
